import React, { ReactNode } from 'react';
import { useSelector } from 'react-redux';

import { selectHeight as selectWizardHeight } from '../../../common/store/wizard';
import Overlay from '../../../common/components/overlay/Overlay';
import {
  Marker,
  DraggableMarker,
  MapCenterDraggableMarker,
} from '../marker/Marker';
import POIIcon from '../poi-icon/POIIcon';
import GuidanceLabel from '../guidance-label/GuidanceLabel';
import { CountryBoundariesTransparentLayer } from '../layers/country-boundaries-transparent-layer/CountryBoundariesTransparentLayer';
import { sidepanelPadding } from '../../utils/hooks/useMapPadding';

import { useMapItemAdd } from './useMapItemAdd';

const MapItemAdd = () => {
  const {
    markerLocation,
    locationSelectable,
    isMobile,
    handleDragEnd,
    correctCoordinates,
    overlayParams,
  } = useMapItemAdd();

  let marker: ReactNode | null = null;
  if (markerLocation) {
    if (locationSelectable) {
      if (isMobile) {
        marker = (
          <MapCenterDraggableMarker
            id="new-position-marker"
            location={markerLocation}
            onDragEnd={handleDragEnd}
            beforeCoordinatesUpdate={correctCoordinates}
          >
            <POIIcon />
          </MapCenterDraggableMarker>
        );
      } else {
        marker = (
          <DraggableMarker
            id="new-position-marker"
            location={markerLocation}
            onDragEnd={handleDragEnd}
            beforeCoordinatesUpdate={correctCoordinates}
          >
            <POIIcon />
          </DraggableMarker>
        );
      }
    } else {
      marker = (
        <Marker location={markerLocation}>
          <POIIcon />
        </Marker>
      );
    }
  }

  const wizardHeight = useSelector(selectWizardHeight);

  return (
    <>
      <CountryBoundariesTransparentLayer />
      {overlayParams && (
        <Overlay
          className="map__overlay"
          style={{ paddingBottom: wizardHeight || 0 }}
        >
          <GuidanceLabel
            className="map-item-add__guidance-label"
            icon={overlayParams.icon}
            style={isMobile ? null : { marginLeft: sidepanelPadding.left }}
          >
            {overlayParams.text}
          </GuidanceLabel>
        </Overlay>
      )}

      {marker}
    </>
  );
};

export default MapItemAdd;
